import {
    GET_REGISTERED_USERS,
    SET_NEW_GROUP,
    REMOVE_GROUP,
    GET_GROUPS,
    EDIT_GROUP,
    ADD_GROUP_MESSAGE,
    GET_DEPARTMENTS, GET_AREAS,
} from "./types";

import firebase from "firebase/app";

export const getRegisteredUsers = () => {
    return dispatch => {
        dispatch({ type: GET_REGISTERED_USERS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_REGISTERED_USERS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/users")
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_REGISTERED_USERS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_REGISTERED_USERS.FAIL });
        }
    };
};
export const getGroups = () => {
    return dispatch => {
        dispatch({ type: GET_GROUPS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_GROUPS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/subjects/message_groups")
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_GROUPS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_GROUPS.FAIL });
        }
    };
};
export const setNewGroup = group => {
    return dispatch => {
        dispatch({ type: SET_NEW_GROUP.REQUEST });
        let count_id;
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) dispatch({ type: SET_NEW_GROUP.FAIL });
                firebase
                    .database()
                    .ref(`/subjects/message_groups`)
                    .once("value")
                    .then(async function(snapshot) {
                        count_id = snapshot.val(); // "last"
                        if (
                            typeof count_id !== "undefined" &&
                            count_id !== null
                        )
                            group["group_id"] = (
                                "000000" +
                                (parseInt(
                                    Object.keys(count_id)[
                                        Object.keys(count_id).length - 1
                                    ]
                                ) +
                                    1)
                            ).slice(-6);
                        else group["group_id"] = "000001";
                        group["group_image"] = await uploadMessageImages(
                            group["group_image"],
                            group["group_id"]
                        );
                        firebase
                            .database()
                            .ref("/subjects/message_groups")
                            .child(group.group_id)
                            .update(group);
                        dispatch({ type: SET_NEW_GROUP.SUCCESS });
                    });
            });
        } catch (e) {
            dispatch({ type: SET_NEW_GROUP.FAIL });
        }
    };
};
export const uploadMessageImages = async (imgBlob = "", messageID = "") => {
    if (imgBlob && messageID) {
        let imgUploadURL = firebase
            .storage()
            .ref(`/messageGroups/${messageID}/groupImg`)
            .put(imgBlob)
            .then(async snapshot => {
                try {
                    const url = await snapshot.ref.getDownloadURL();
                    return url;
                } catch (e) {
                    return "";
                }
            })
            .catch(() => {
                return "";
            });
        return imgUploadURL;
    } else {
        return "";
    }
};

export const editGroup = group => {
    return dispatch => {
        dispatch({ type: EDIT_GROUP.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(async user => {
                if (user === null) {
                    dispatch({ type: EDIT_GROUP.FAIL });
                } else {
                    firebase
                        .database()
                        .ref(`/subjects/message_groups/${group.group_id}`)
                        .update(group);

                    dispatch({ type: EDIT_GROUP.SUCCESS });
                }
            });
        } catch (e) {
            dispatch({ type: EDIT_GROUP.FAIL });
        }
    };
};
export const editGroupImage = group => {
    return dispatch => {
        dispatch({ type: EDIT_GROUP.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(async user => {
                if (user === null) {
                    dispatch({ type: EDIT_GROUP.FAIL });
                } else {
                    group["group_image"] = await uploadMessageImages(
                        group["group_image"],
                        group["group_id"]
                    );
                    firebase
                        .database()
                        .ref(`/subjects/message_groups/${group.group_id}`)
                        .update(group);

                    dispatch({ type: EDIT_GROUP.SUCCESS });
                }
            });
        } catch (e) {
            dispatch({ type: EDIT_GROUP.FAIL });
        }
    };
};
export const removeGroup = uid => {
    return dispatch => {
        dispatch({ type: REMOVE_GROUP.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: REMOVE_GROUP.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/subjects/message_groups")
                        .child(uid)
                        .remove();
                    dispatch({ type: REMOVE_GROUP.SUCCESS });
                }
            });
        } catch (e) {
            dispatch({ type: REMOVE_GROUP.FAIL });
        }
    };
};

export const addMessages = (uid, messages) => {
    return dispatch => {
        dispatch({ type: ADD_GROUP_MESSAGE.REQUEST });
        try {
            firebase.auth().onAuthStateChanged(async user => {
                if (user === null) {
                    dispatch({ type: ADD_GROUP_MESSAGE.FAIL });
                } else {
                    messages["sender"] = user.uid;
                    if (messages["attatched_image_url"]) {
                        messages[
                            "attatched_image_url"
                        ] = await uploadMessagePhotos(
                            messages["attatched_image_url"],
                            uid,
                            messages["timestamp"]
                        );
                        firebase
                            .database()
                            .ref(
                                `/subjects/message_groups/${uid}/messages_in_group/`
                            )
                            .push()
                            .set(messages);
                        firebase
                            .database()
                            .ref(
                                `/subjects/message_groups/${uid}/most_recent_message`
                            )
                            .set(messages);
                        dispatch({ type: ADD_GROUP_MESSAGE.SUCCESS });
                    } else {
                        firebase
                            .database()
                            .ref(
                                `/subjects/message_groups/${uid}/messages_in_group/`
                            )
                            .push()
                            .set(messages);
                        firebase
                            .database()
                            .ref(
                                `/subjects/message_groups/${uid}/most_recent_message`
                            )
                            .set(messages);
                        dispatch({ type: ADD_GROUP_MESSAGE.SUCCESS });
                    }
                }
            });
        } catch (e) {
            dispatch({ type: ADD_GROUP_MESSAGE.FAIL });
        }
    };
};

export const uploadMessagePhotos = async (
    imgBlob = "",
    messageID = "",
    timestamp = ""
) => {
    if (imgBlob && messageID) {
        let imgUploadURL = firebase
            .storage()
            .ref(
                `/messageGroups/${messageID}/images/${timestamp} - ${imgBlob.name}`
            )
            .put(imgBlob)
            .then(async snapshot => {
                try {
                    const url = await snapshot.ref.getDownloadURL();
                    return url;
                } catch (e) {
                    return "";
                }
            })
            .catch(() => {
                return "";
            });
        return imgUploadURL;
    } else {
        return "";
    }
};
export const getDepartments = () => {
    return dispatch => {
        dispatch({ type: GET_DEPARTMENTS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_DEPARTMENTS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/departments")
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_DEPARTMENTS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_DEPARTMENTS.FAIL });
        }
    };
};
export const getAreas = () => {
    return dispatch => {
        dispatch({ type: GET_AREAS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_AREAS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/areas")
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_AREAS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_AREAS.FAIL });
        }
    };
};